import { SAFE_HREF_PATTERN, WA_PATTERN } from "./primitives";
import { websiteDefinitionSchema, type WebsiteDefinition } from "./definition";

export interface DefinitionIssue {
  path: string;
  message: string;
}

export type ParseResult =
  | { ok: true; data: WebsiteDefinition }
  | { ok: false; issues: DefinitionIssue[] };

/** Validate untrusted input (API responses, stored drafts, AI output) before rendering. */
export function parseDefinition(input: unknown): ParseResult {
  const result = websiteDefinitionSchema.safeParse(input);
  if (result.success) return { ok: true, data: result.data };
  return {
    ok: false,
    issues: result.error.issues.map((i) => ({ path: i.path.join("."), message: i.message })),
  };
}

export function isSafeHref(value: string | undefined | null): value is string {
  return typeof value === "string" && value.length <= 2048 && SAFE_HREF_PATTERN.test(value);
}

/**
 * Normalize Indonesian phone input to WhatsApp format (62...).
 * "0812-3456-7890" | "+62 812 3456 7890" | "812345678" -> "628123456789". Returns null if invalid.
 */
export function normalizeWhatsApp(input: string): string | null {
  let digits = input.replace(/[^0-9]/g, "");
  if (digits.startsWith("0")) digits = "62" + digits.slice(1);
  else if (digits.startsWith("8")) digits = "62" + digits;
  return WA_PATTERN.test(digits) ? digits : null;
}

/** Display format: 62812345678 -> +62 812-3456-78 */
export function formatWhatsApp(wa: string): string {
  const local = wa.replace(/^62/, "");
  return `+62 ${local.slice(0, 3)}-${local.slice(3, 7)}-${local.slice(7)}`.replace(/-$/, "");
}
